
  import { defineComponent, onMounted, ref } from 'vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useRoute, useRouter } from 'vue-router';
  import { useAbility } from '@casl/vue';

  export default defineComponent({
    name: 'purchase-logs-overview',
    components: {},
    setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const route = useRoute();
      const router = useRouter();
      const { can } = useAbility();
      const purchaseLog = ref<any | null>(null);

      const translate = (text, options = {}) => {
        if (te(text)) {
          return t(text, options);
        } else {
          return text;
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('purchaseLogOverview'), [
          translate('purchaseLogs'),
        ]);
        const { data } = await store.dispatch(
          Actions.GET_PURCHASE_LOG,
          route.params.id
        );
        purchaseLog.value = data.data;
      });

      const goBack = () => {
        router.back();
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        purchaseLog,
        translate,
        can,
        goBack,
      };
    },
  });
